export const GET_COLLECTIONS = "app/GET_COLLECTIONS";
// export const SEND_BRIDE_FORM = "app/SEND_BRIDE_FORM";
